import React from 'react';
import { Box, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ProductDetailsContentStyled } from '../shared/Product/ProductDetailsContentStyled';
import { ProductDetailsException } from '../../utils/constans/ProductPage';
import { ProductDetailsProps } from '../../models/ProductPage';

const StyledWrapper = styled(Box)(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    borderBottom: '1px solid #e6e6e6',
    padding: '20px 0',
    [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
    },
}));

export const ProductDetails: React.FC<ProductDetailsProps> = (props) => {
    const { product, variant } = props;

    const { t } = useTranslation('product');

    const getDetail = (tag: string) => {
        if (
            !ProductDetailsException.some(function (v) {
                return tag.indexOf(v) >= 0;
            })
        ) {
            const tagName = tag.split('|')[0];
            const tagValue = tag.split('|')[1];
            return tagValue ? (
                <ProductDetailsContentStyled
                    name={tagName}
                    value={tagValue}
                    key={tagName}
                />
            ) : null;
        }
        return null;
    };

    return (
        <StyledWrapper>
            <ProductDetailsContentStyled
                name={t('PRODUCT.VENDOR')}
                value={product.vendor}
            />
            <ProductDetailsContentStyled
                name={t('PRODUCT.SKU')}
                value={variant.sku}
            />
            {product.tags.map((tag) => (
                <>{getDetail(tag)}</>
            ))}
        </StyledWrapper>
    );
};
